import React, { useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import Link from 'next/link'
import { FiChevronRight } from 'react-icons/fi'
import { HiOutlineArrowNarrowLeft } from 'react-icons/hi'
// import { AiOutlineSafety } from 'react-icons/ai'
import Dialog from '@mui/material/Dialog'
import Button from '../Button'
import { icons } from '../SocialList'
import Icon from '../Icon'
import LotteryReport from '../lottery/LotteryReport'
import getCountryTimeZone from '../../utils/deliveryData'
import Support from '../icon/Support'
// import { useMemo } from 'hoist-non-react-statics/node_modules/@types/react'
// import { PropsWithChildren } from 'react-transition-group/node_modules/@types/react'

const COUPONS_LIST = [
  { KEY: 5, TEXT: '$5 OFF $39' },
  { KEY: 10, TEXT: '$10 OFF $69' },
  { KEY: 15, TEXT: '$15 OFF $99' },
  { KEY: 20, TEXT: '$20 OFF $129' },
  { KEY: 25, TEXT: '$25 OFF $159' },
]

export const CouponsList = () => {
  const [open, setOpen] = useState<boolean>(false)
  const [index, setIndex] = useState<number>(0)
  function handleCouponDialog(idx: number) {
    setIndex(idx)
    setOpen(true)
  }
  return (
    <div>
      <Dialog
        open={open}
        maxWidth="xl"
        onClose={() => setOpen(false)}
        transitionDuration={0}
      >
        <div className="flex flex-col justify-center items-center h-70 px-5 py-10 overflow-hidden mt-3.5">
          <div className="coupon--item h-20 text-2xl font-semibold w-64 mr-0">
            {COUPONS_LIST[index].TEXT}
          </div>
          <div className="text-black text-15 font-bold mt-9 mb-3">
            Coupon code: LOVE{COUPONS_LIST[index].KEY}
          </div>
          <div className="text-black text-opacity-70 text-sm mb-8">
            Apply a coupon code at checkout.
          </div>
          <div
            className="flex w-full justify-center items-center h-11 bg-black text-white cursor-pointer"
            onClick={() => setOpen(false)}
          >
            OK
          </div>
        </div>
      </Dialog>
      <div className="coupon-wrapper pl-3 pt-4 pb-4 md:hidden">
        <h2 className="coupon-tit text-black text-sm font-semibold mb-2">
          Coupons
        </h2>
        <div className="coupon-list h-7 flex flex-nowrap overflow-y-hidden overscroll-x-auto nobar">
          {COUPONS_LIST.map((i, idx) => (
            <div
              className="coupon--item h-7 text-xs mr-2 font-semibold"
              key={i.KEY}
              onClick={() => handleCouponDialog(idx as number)}
            >
              {i.TEXT}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

// 切割条
export const SplitBar = () => <div className="splitbar md:hidden" />

// 运费说明
export const DeliveryInfo = () => {
  const [result, setResult] = useState<any>('')
  const router = useRouter()
  useEffect(() => {
    if (process.browser && !router.isFallback) {
      setResult(getCountryTimeZone())
    }
  }, [router.isFallback])

  return (
    result && (
      <div className="delivery-wrapper pt-4 px-3 pr-0 md:px-0 md:mb-3.5">
        <h2 className="coupon-tit text-black text-sm leading-1.6 font-semibold">
          <span className="md:hidden">Shipping & Returns</span>
          {/* <span className="hidden md:block">Shipping to {result.country}</span> */}
        </h2>
        <div className="delivery--item pb-2.5">
          <Link href="/pages/shipping-1" passHref prefetch={false}>
            <div className="flex justify-between items-center pt-3 pb-1.5 mr-3 md:pointer-events-none">
              <div className="text-12 inline-flex items-center md:pointer-events-none">
                <Icon name="logistics" width={20} height={20} />
                <span className="ml-2">Delivery to {result.country}</span>
              </div>
              <div className="flex flex-1 justify-end items-center md:hidden">
                <div className="leading-1.2 text-10 text-gray-400">More</div>
                <FiChevronRight size={16} color="#999999" />
              </div>
            </div>
          </Link>
          <div className="flex flex-nowrap overflow-y-hidden overscroll-x-auto md:overflow-hidden nobar">
            <div className="md:w-1/2 inline-flex flex-col bg-tag-grayf5 flex-shrink-0 text-xs box-border leading-normal mr-2 text-gray-400 py-2.5 pl-3 pr-5">
              <div className="mb-1.5">
                <div>
                  Standard shipping:&nbsp;
                  <span className="text-xs text-black">
                    ${result.shippingPrice.standard}
                  </span>
                </div>
                <div>
                  Free for orders over&nbsp;
                  <span className="text-xs text-tag-greens">$59</span>
                </div>
              </div>
              <div className="break-all">
                Estimated delivery on <br />
                <span>{result.standardDays[0]}</span>
                &nbsp;-&nbsp;
                <span>{result.standardDays[1]}</span>
              </div>
            </div>
            <div className="md:w-1/2 inline-flex flex-col bg-tag-grayf5 flex-shrink-0 text-xs box-border leading-normal mr-2 text-gray-400 py-2.5 pl-3 pr-5">
              <div className="mb-1.5">
                <div>
                  Express shipping:&nbsp;
                  <span className="text-xs text-black">
                    ${result.shippingPrice.express}
                  </span>
                </div>
                {/* <div>
              Free on orders over:
              <span className="text-xs font-semibold text-tag-greens">$99</span>
            </div> */}
              </div>
              <div className="break-all">
                Estimated delivery on <br />
                <span>{result.exppressDays[0]}</span>
                &nbsp;-&nbsp;
                <span>{result.exppressDays[1]}</span>
              </div>
            </div>
          </div>
          <div className="text-10 text-gray-400 flex mt-2.5 mr-3">
            <Icon
              name="delivery_tips"
              className="mr-0.5"
              width={14}
              height={14}
            />
            <span className=" inline-flex flex-1">
              Delivery times will be slightly longer than normal due to global
              supply chain disruptions throughout the New Year&lsquo;s Day.
            </span>
          </div>
        </div>
        {/* <div className="delivery--item border-t py-3 border-b md:hidden mr-3 border-tag-graye9">
          <div className="flex justify-between items-center">
            <div className="text-12 inline-flex items-center">
              <Icon name="guarantee" width={23.68} height={23.68} />
              <div className="ml-2">
                <span>The Bloom Guarantee: </span>
                <span className="text-gray-400">
                  Full refund on shipping if a delay occurs.
                </span>
              </div>
            </div>
          </div>
        </div> */}
        <div className="delivery--item py-3 md:hidden mr-3">
          <Link href="/pages/return-policy" passHref prefetch={false}>
            <div className="flex justify-between items-center">
              <div className="text-12 flex items-center">
                <Icon name="freereturn_icon" width={20} height={20} />
                {/* <span>{ProductsSVG.free}</span> */}
                <div className="ml-2">
                  <span>Free Returns</span>
                </div>
              </div>
              {/* <a href="/" title="xxx"> */}
              <div className="inline-flex items-center">
                <div className="leading-1.2 text-10 text-gray-400">Details</div>
                <FiChevronRight size={16} color="#999999" />
              </div>
              {/* </a> */}
            </div>
          </Link>
        </div>
      </div>
    )
  )
}

interface FooterProps {
  canBuy: boolean
  forBtn?: boolean
  loading?: boolean
  errorMsg?: string
  onAddClick?: () => void
}

export const ProductFooter = (props: FooterProps) => {
  const { canBuy, onAddClick, forBtn, loading, errorMsg } = props

  const handleAddClick = () => {
    if (!canBuy) return
    LotteryReport('lottery_add_to_cart')
    onAddClick?.()
  }

  return (
    <div className="buy-wrapper">
      {forBtn ? (
        <>
          <Button
            loading={loading}
            disabled={!canBuy}
            className="button--primary text-sm hidden py-3 md:block w-full"
            onClick={handleAddClick}
          >
            {canBuy ? 'Add To Cart' : 'Sold Out'}
          </Button>
          {errorMsg && (
            <div className="hidden md:block text-sm text-center px-3 py-1.5 border-1 border-tag-error text-tag-error">
              {errorMsg}
            </div>
          )}
        </>
      ) : (
        <>
          <div className="fixed bottom-0 w-full h-14 flex items-center bg-white z-20 cursor-pointer md:hidden">
            <div
              className="flex flex-col w-20 leading-1 items-center h-14 justify-center"
              onClick={() => {
                // @ts-ignore
                ud('showPanel')
                // @ts-ignore
                $BasePageSensor.ChatClick()
              }}
            >
              <Support className="w-4.5 h-7 pt-1" />
              <span className="text-xs">Support</span>
            </div>
            <Button
              loading={loading}
              onClick={handleAddClick}
              disabled={!canBuy}
              className="button--primary h-14 font-semibold w-full tracking-normal"
            >
              {canBuy ? 'Add To Cart' : 'Sold Out'}
            </Button>
          </div>
          {/* <div className="hidden md:flex cursor-pointer fixed bottom-6 right-6 z-40 rou overflow-hidden rounded-full text-white bg-black w-14 h-14 justify-center items-center"> */}
          {/*  <RiCustomerService2Line size={25} color="#fffff" /> */}
          {/* </div> */}
        </>
      )}
    </div>
  )
}

const iconsList = [
  {
    title: 'Share',
    iconName: 'facebook',
    domain: 'https://www.facebook.com/sharer.php',
    link: 'u=url',
  },
  {
    title: 'Tweet',
    iconName: 'tweet',
    domain: 'https://twitter.com/share',
    link: 'text=title&url=url',
  },
  {
    title: 'Pin it',
    iconName: 'pinterest',
    domain: 'https://pinterest.com/pin/create/button',
    link: 'url=url&media=image&description=title',
  },
]
interface ShareProps {
  open?: boolean
  data?: any
  onOpenChange?: (b: boolean) => void
}

export const ProductShare = (props: ShareProps) => {
  const { open, data, onOpenChange } = props
  const [shareData, setShareData] = useState<any[]>([...iconsList])
  useEffect(() => {
    if (!data) {
      return
    }
    const title = data?.title // https://service-hh4bv970-1253813979.gz.apigw.tencentcs.com // encodeURIComponent(window.location.href)
    const imgurl =
      data?.images?.edges?.length > 0 ? data.images.edges[0].node.src : ''
    const link = window.location.href
    shareData[0].link = `${shareData[0].domain}?u=${link}`
    shareData[1].link = `${shareData[1].domain}?text=${title}&url=${link}`
    shareData[2].link = `${shareData[2].domain}?url=${link}&media=${imgurl}&description=${title}`
    setShareData([...shareData])
  }, [data.images])

  return (
    <div className="">
      <div
        className={`fixed top-0 left-0 w-full h-full md:z-0 ${
          open ? 'block z-50' : 'hidden'
        } md:hidden bg-black bg-opacity-50`}
        onClick={() => {
          onOpenChange?.(false)
        }}
      />
      <div
        className={`share-wrapper md:flex ${
          open ? 'sm:flex z-50' : 'hidden'
        } flex felx-full items-center justify-center text-sm p-4 md:p-10 fixed bottom-0 left-0 right-0 w-full bg-white sm:h-15 md:relative`}
      >
        {shareData.map((i: any, idx: any) => (
          <a
            className="inline-flex justify-center mx-5"
            target="_blank"
            href={i.link}
            key={idx}
            rel="noreferrer"
          >
            <span className="w-5 h-5 text-sm inline-block mr-2">
              {icons[i?.iconName]}
            </span>
            {i.title}
          </a>
        ))}
      </div>
    </div>
  )
}

export const BackToCollection = () => {
  const router = useRouter()
  let { collectionTitle } = router.query
  if (collectionTitle) {
    collectionTitle = (collectionTitle as string)
      .split('-')
      .map((i) => i[0].toUpperCase() + i.slice(1))
      .join(' ')
  }
  return collectionTitle ? (
    <div className="justify-center w-full hidden md:flex">
      <div
        className=" bg-black text-white inline-flex items-center h-12 px-5 mt-10 cursor-pointer mb-5"
        onClick={() => {
          router.back()
        }}
      >
        <HiOutlineArrowNarrowLeft size={20} className="mr-2" />
        Back to {collectionTitle}
      </div>
    </div>
  ) : (
    <></>
  )
}
